export const Behavior = {
    Copy: 'Copy',
    CopyWithRelations: 'CopyWithRelations',
    Both: 'Both',
    CopyToType: 'CopyToType'
};